module.exports = __webpack_public_path__ + "dollar_blue_bold.c02e2a6e9c26ed8cba376165b366de3f.svg";